import React, {useState} from 'react';
import {t} from 'i18next';
import menuImage from '../../../images/menu.webp';
import bageta from '../../../images/bageta2.webp';
import {FoodSection} from '../types/FoodSection';
import {getFoodSections} from './foodUtils';
import {Food} from '../types/Food';
import {getAppendedClassWithDevice} from '../../../shared/utils/deviceUtils';
import './FoodList.scss';
import {OpeningHours} from "./OpeningHours/OpeningHours";

type FoodListParameters = {
    isMobile?: boolean;
};

export const FoodList = (params: FoodListParameters = {
    isMobile: false
}) => {
    const [foodSections] = useState<FoodSection[]>(() => getFoodSections());

    const getListClass = (sectionIndex: number, foodSection: FoodSection): string =>
        getAppendedClassWithDevice(`food-list-${sectionIndex} ${foodSection.startQueueNumber == null ? 'type-none' : ''}`, params.isMobile);

    return (
        <div className={getAppendedClassWithDevice('food-list-container', params.isMobile)}>
            <div className={getAppendedClassWithDevice('images', params.isMobile)}>
                <img src={menuImage} alt="menu" className="menu-image"/>
                {!params.isMobile && (<OpeningHours/>)}
                <img src={bageta} alt="bageta" className="bageta"/>
            </div>
            <div className={getAppendedClassWithDevice('food-list', params.isMobile)}>
                {foodSections.map((foodSection: FoodSection, sectionIndex: number) => (
                    <div
                        className="food-card"
                        key={`food-section-${sectionIndex}`}
                    >
                        <div className="title">
                            <span>{foodSection.title}</span>
                            {foodSection.minWeight && (<span>{t('MinWeight')}: {foodSection.minWeight}g</span>)}
                        </div>
                        <div className="foods">
                            <ol className={getListClass(sectionIndex, foodSection)}
                                start={foodSection.startQueueNumber}>
                                {foodSection.foods.map((food: Food, foodIndex: number) => (
                                    <li key={`food-section-${sectionIndex}-food-${foodIndex}`}>
                                        <div className="d-flex justify-content-between">
                                            <div className="food-description">
                                                {food.name} {food.description && (<span>({food.description})</span>)}
                                            </div>
                                            <div className="price">
                                                {food.allergens && (<span className="allergens">{food.allergens}</span>)}
                                                {food.price.toFixed(2)} €
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </div>
                ))}
                <div className="food-card">
                    <div className="title">
                        {t('Allergens')}
                    </div>
                    <ol className={getAppendedClassWithDevice('allergens-list', params.isMobile)}>
                        <li>{t('Milk')}</li>
                        <li>{t('Fish')}</li>
                        <li>{t('Mustard')}</li>
                        <li>{t('Eggs')}</li>
                        <li>{t('SezameSeeds')}</li>
                        <li>{t('Cereals')}</li>
                        <li>{t('Soja')}</li>
                        <li>{t('Gluten')}</li>
                    </ol>
                </div>
            </div>
        </div>
    );
};
